import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	isChangeOnlyOption: ForNodeType<boolean>;
	onSetViewModel: (
		values: {
			key: "isChangeOnlyOption";
			value: ForNodeType<boolean>;
		}[],
	) => void;
};

export const usePlanIsChangeOnlyOption = ({ isChangeOnlyOption, onSetViewModel }: Props) => {
	const onSetIsChangeOnlyOption = (value: boolean) => {
		onSetViewModel([
			{
				key: "isChangeOnlyOption",
				value: {
					isEdited: true,
					value,
				},
			},
		]);
	};

	return {
		isChangeOnlyOption,
		onSetIsChangeOnlyOption,
	};
};
